import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { createApp } from 'vue'
import App from './App.vue'
import { setupRouter } from '@/router'
import { setupStore } from '@/store'
import 'amfe-flexible'
import '@/assets/css/global.less'
import Storage from './utils/Storage'
import { IOS_WX_ENTRY_URL } from '@/enums/cacheEnum'
import { banIOSRubberBand } from '@/utils/ios'

banIOSRubberBand()
Storage.set(IOS_WX_ENTRY_URL, location.href)

const app = createApp(App)

async function setupApp() {
  // 挂载pinia状态管理
  setupStore(app)
  // 挂载路由
  await setupRouter(app)
  app.mount('#app')
}
setupApp()
